const logo = require('../assets/images/logo.png')
const avatar = require('../assets/images/avatar.jpg')
const banner = require('../assets/images/banner.png')

export default {
    logo,
    avatar,
    banner,
}
